import { render } from "./UpdateDataForm.vue?vue&type=template&id=06a31aaa&scoped=true"
import script from "./UpdateDataForm.vue?vue&type=script&lang=js"
export * from "./UpdateDataForm.vue?vue&type=script&lang=js"

import "./UpdateDataForm.vue?vue&type=style&index=0&id=06a31aaa&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\Leads\\leads-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06a31aaa"]])

export default __exports__